import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalCreateCompanyForm = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;
  const [companyName, setCompanyName] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    // Check if all form fields are filled to enable the submit button
    setIsFormValid(companyName && companyPhone && companyEmail && companyAddress);
  }, [companyName, companyPhone, companyEmail, companyAddress]);

  const handleInputChange = (e) => {
    const { id, value, files } = e.target;
    if (id === "companyLogo") {
      setCompanyLogo(files[0]);
    } else {
      switch (id) {
        case "companyName":
          setCompanyName(value);
          break;
        case "companyPhone":
          setCompanyPhone(value);
          break;
        case "companyEmail":
          setCompanyEmail(value);
          break;
        case "companyAddress":
          setCompanyAddress(value);
          break;
        default:
          break;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("companyName", companyName);
    formData.append("companyPhone", companyPhone);
    formData.append("companyEmail", companyEmail);
    formData.append("companyAddress", companyAddress);
    formData.append("companyLogo", companyLogo);
    formData.append("apiType", 'registerCompany');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        const data = response.data;
        setCompanyName("");
        setCompanyPhone("");
        setCompanyEmail("");
        setCompanyAddress("");
        setCompanyLogo(null);
        if (data === 'Upload Completed Successfully' || data === '') {
          alert('Data Upload Completed Successfully');
        } else {
          alert(data);
        }
      })
      .catch(error => {
        alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
      });
  };

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalCreateCompanyForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content mt-5">
          <div className="modal-header ">
            <p className="heading lead">Register Company</p>
           
          </div>
          <div className="modal-body">
            <form id="fileUploadFormRegisterCompany" onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-4 text-left">
                  <div className="md-form md-outline">
                    <input type="text" id="companyName" name="companyName" className="form-control" value={companyName} onChange={handleInputChange} required />
                    <label htmlFor="companyName">Company Name</label>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 mb-4 text-left">
                  <div className="md-form md-outline">
                    <input type="text" id="companyPhone" name="companyPhone" className="form-control" value={companyPhone} onChange={handleInputChange} required />
                    <label htmlFor="companyPhone">Company Phone</label>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 mb-4 text-left">
                  <div className="md-form md-outline">
                    <input type="text" id="companyEmail" name="companyEmail" className="form-control" value={companyEmail} onChange={handleInputChange} required />
                    <label htmlFor="companyEmail">Company Email</label>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 mb-4 text-left">
                  <div className="md-form md-outline">
                    <textarea id="companyAddress" name="companyAddress" className="form-control" value={companyAddress} onChange={handleInputChange} required></textarea>
                    <label htmlFor="companyAddress">Company Address</label>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 mb-4 text-left">
                  <div className="">
                    <label htmlFor="companyLogo">Company Logo</label>
                    <input type="file" className="form-control" id="companyLogo" name="companyLogo" onChange={handleInputChange} />
                  </div>
                </div>
                <input type="hidden" id="apiType" name="apiType" value="registerCompany" />
                <div className="text-center mt-0">
                  <button type="submit" className="btn btn-success" id="registerCompany" disabled={!isFormValid}>Register <i className="fas fa-coins ml-1"></i></button>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalCreateCompanyForm;
